module.exports = __webpack_public_path__ + "static/media/b8.f636d705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/thumbnails/b8.png
// module id = 329
// module chunks = 0